import React, { useState, useEffect } from 'react';
import { Button, Card, Container, Grid } from '@material-ui/core';
import { AutoPaysVService } from '../../services/V2/gozer';
import { formatMoney, handleError, handleErrorToast } from '../shared/Functions';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { getAutoPaymentBatch } from '../shared/ExportFunctions';
import { DistrictsVService } from '../../services/V2/padre';
import { useParams } from 'react-router-dom';
import { authProvider } from '../../services/Security';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';

export const AutoPaymentBatch = ({errorToast, successToast}) => {
    const { paymentId } = useParams<{ paymentId: string }>();
    const [payments, setPayments] = useState<any>();
    const [district, setDistrict] = useState<any>();
    const [cancelWarning, setCancelWarning] = useState<boolean>(false);
    const [noRunList, setNoRunList] = useState<any[]>([]);
    const [runList, setRunList] = useState<any[]>([]);
    const [disablePayments, setDisablePayments] = useState<boolean>(false);
    const [connection, setConnection] = useState<any>(null);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if(!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token);
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${process.env.GOZER_HOST}/hub/RecurringPayments`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets
              })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection && district) {
            connection.start()
                .then(result => {
                    connection.on('RecurringMessage', message => {
                        var data = message
                        if(data.districtId !== district.id) return;
                        if(!data) errorToast("Something Failed")
                        else if(!data.id) errorToast(data.message)
                        else {
                            successToast(`Success! ${data.successes} succeeded, ${data.failures} failed.`)
                            setDisablePayments(false)
                            setPayments(data)
                        }
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection, district]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        AutoPaysVService.autoPaysVGetBatch(paymentId)
            .then((x: any) => {
                setNoRunList(x?.details?.filter(y => !y?.processPayment))
                setRunList(x?.details?.filter(y => y?.processPayment))
            }).catch(x => {
                errorToast(handleErrorToast(x))
            })
        AutoPaysVService.autoPaysVGetById(paymentId)
            .then((x: any) => {
                setPayments(x)
                setDisablePayments(x.hasBeenRun)
                DistrictsVService.districtsVGetById(x?.districtId)
                    .then((x) => {
                        setDistrict(x)
                    }).catch(x => {
                        errorToast(handleErrorToast(x))
                    })
            }).catch(x => {
                errorToast(handleErrorToast(x))
            })
    }, [paymentId])// eslint-disable-line react-hooks/exhaustive-deps

    const handleDownload = () => {
        getAutoPaymentBatch(paymentId, (new Date()).toLocaleString())
            .then(x => {})
            .catch(err => handleError(err))
    }

    const getListStyle = (isDraggingOver, list) => ({
        background: list === "no-run" ? isDraggingOver ? "pink" : "lightgrey" :
            isDraggingOver ? "lightgreen" : "lightblue",
        padding: 8,
        width: "100%",
        height:"75vh",
        overflow:"auto",
        margin:"10px"
    });

    const onDragEnd = result => {
        // dropped outside the list
        if (!result.destination) {
          return;
        }
        if(result.destination.droppableId === "droppable-run" && result.source.droppableId === "droppable-no-run"){
            let list = Array.from(noRunList);
            let [removed] = list.splice(result.source.index, 1);
            setNoRunList(list);

            let newList = addItem(runList, result.destination.index, removed);
            setRunList(newList)
        } else if(result.destination.droppableId === "droppable-no-run" && result.source.droppableId === "droppable-run"){
            let list = Array.from(runList);
            let [removed] = list.splice(result.source.index, 1);
            setRunList(list);

            let newList = addItem(noRunList, result.destination.index, removed);
            setNoRunList(newList)
        } else if(result.destination.droppableId === "droppable-run" && result.source.droppableId === "droppable-run"){
            let items = reorder(
                runList,
                result.source.index,
                result.destination.index
            );
            setRunList(items);
        } else if(result.destination.droppableId === "droppable-no-run" && result.source.droppableId === "droppable-no-run"){
            let items = reorder(
                noRunList,
                result.source.index,
                result.destination.index
            );
            setNoRunList(items);
        }
    }

    const reorder = (list, startIndex, endIndex) => {
        setCancelWarning(true)
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const addItem = (list, endIndex, item) => {
        setCancelWarning(true)
        const result = Array.from(list);
        result.splice(endIndex, 0, item);

        return result;
    };

    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: 16,
        margin: `0 0 8px 0`,
        // change background colour if dragging
        background: isDragging ? "lightgreen" : "white",
        // styles we need to apply on draggables
        ...draggableStyle
    });

    const handleSave = () => {
        let notRun = Array.from(noRunList);
        let run = Array.from(runList);
        notRun.forEach(x => x.processPayment = false);
        run.forEach(x => x.processPayment = true);
        let fullList = notRun.concat(run)

        AutoPaysVService.autoPaysVUpdateBatch(paymentId, fullList)
            .then((x:any) => {
                setNoRunList(x.details.filter(y => !y.processPayment))
                setRunList(x.details.filter(y => y.processPayment))
            })
            .catch(err => handleError(err))
    }

    const handleCancel = () =>{
        if(cancelWarning){
            let confirm = window.confirm("The edits to the batch hasn't been saved. Are you sure you want to cancel?");
            if(!confirm) return;
            AutoPaysVService.autoPaysVGetBatch(paymentId)
                .then((x: any) => {
                    setCancelWarning(false)
                    setNoRunList(x?.details?.filter(y => !y?.processPayment))
                    setRunList(x?.details?.filter(y => y?.processPayment))
                }).catch(x => {
                    errorToast(handleErrorToast(x))
                })
        } else successToast("No changes were made.")
    }

    const handleRun = () => {
        let confirm = window.confirm(`Are you sure you want to run Recurring Payments for all Billing Accounts for ${district.name}?`);

        if (confirm === true) {
            setDisablePayments(true)
            AutoPaysVService.autoPaysVPostAutoPay(payments.id)
                .then(x => {
                    successToast(`Running. You can leave the page and come back for results or wait here and be redirected once they come in.`);
                    setDisablePayments(true)
                })
                .catch(x => errorToast(handleErrorToast(x)))
        }
    }

    if(!payments) return null;

    return (
        <React.Fragment>
            <Container maxWidth="xl" style={{backgroundColor: "white", height: "1000px", width: "1000px", padding: "50px"}}>
                <h1>District: {district?.name}</h1>
                <h1>Batch Id: {payments?.batchId}</h1>
                <Button disabled={disablePayments} onClick={handleRun} color={"primary"}>Run Batch</Button>
                <Grid container>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Grid item xs={6}>
                            <Droppable droppableId="droppable-no-run" style={{maxHeight: "50px"}}>
                                {(provided, snapshot) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver, "no-run")}
                                        >
                                        <h1>No Run List</h1>
                                        {noRunList.map((item, index) => (
                                            <Draggable
                                                key={`${index}-no-run`}
                                                draggableId={`${index}-no-run`}
                                                index={index}
                                                isDragDisabled={false}
                                                >
                                                {(provided, snapshot) => (
                                                    <Card
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                    >
                                                        <div>
                                                            <div><b>AccountNumber: </b>{item?.billingAccount?.accountNumber}</div>
                                                            <div><b>Full Name: </b>{item?.billingAccount?.customer?.fullName}</div>
                                                            <div><b>AutoPay Token: </b>{item?.token?.cardType ?? item?.token?.achType} {item?.token?.last4}</div>
                                                            <div><b>Amount: </b>{formatMoney(item?.paymentAmount)}</div>
                                                            <div><b>Service Fee: </b>{formatMoney(item?.feeAmount)}</div>
                                                        </div>
                                                    </Card>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </Grid>
                        <Grid item xs={6}>
                            <Droppable droppableId="droppable-run">
                                {(provided, snapshot) => (
                                    <div
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver, "run")}
                                    >
                                        <h1>Run List</h1>
                                        {runList.map((item, index) => (
                                            <Draggable
                                                key={`${index}-run`}
                                                draggableId={`${index}-run`}
                                                index={index}
                                                isDragDisabled={false}
                                                >
                                                {(provided, snapshot) => (
                                                    <Card
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}>
                                                        <div>
                                                            <div><b>AccountNumber: </b>{item?.billingAccount?.accountNumber}</div>
                                                            <div><b>Full Name: </b>{item?.billingAccount?.customer?.fullName}</div>
                                                            <div><b>AutoPay Token: </b>{item?.token?.cardType ?? item?.token?.achType} {item?.token?.last4}</div>
                                                            <div><b>Amount: </b>{formatMoney(item?.paymentAmount)}</div>
                                                            <div><b>Service Fee: </b>{formatMoney(item?.feeAmount)}</div>
                                                        </div>
                                                    </Card>
                                                )}
                                            </Draggable>
                                        ))}
                                    {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </Grid>
                    </DragDropContext>
                </Grid>
                <div>
                    <Button disabled={disablePayments} onClick={handleSave} color={"primary"}>Save</Button>
                    <Button onClick={handleDownload} color={"default"}>Export</Button>
                    <Button disabled={disablePayments} onClick={handleCancel} color={"secondary"}>Cancel</Button>
                </div>
            </Container>
        </React.Fragment>
    );
}